import {
  ApiResponse,
  ComboAcceptResponse,
  ComboActivityItem,
  ComboListParams,
  ComboListResponse,
  ComboMarketsResponse,
  ComboPosition,
  ComboQuote,
  ComboQuoteRequest,
  ComboQuoteResponse,
  ComboRfqStatusResponse,
} from '@/types';
import axiosClient from './axiosClient';

import { API_ENDPOINTS } from '@/constants';

export const combosApi = {
  /** Public: browse combo-eligible markets */
  listMarkets: async (params?: ComboListParams): Promise<ApiResponse<ComboMarketsResponse>> => {
    const { data } = await axiosClient.get<ApiResponse<ComboMarketsResponse>>(
      API_ENDPOINTS.COMBOS.MARKETS,
      { params },
    );
    return data;
  },

  /** Request a quote for a combo of positions */
  requestQuote: async (payload: ComboQuoteRequest): Promise<ApiResponse<ComboQuoteResponse>> => {
    const { data } = await axiosClient.post<ApiResponse<ComboQuoteResponse>>(
      API_ENDPOINTS.COMBOS.QUOTE,
      payload,
    );
    return data;
  },

  /** Accept a previously requested quote */
  acceptQuote: async (
    rfqId: string,
    quote: ComboQuote,
  ): Promise<ApiResponse<ComboAcceptResponse>> => {
    const { data } = await axiosClient.post<ApiResponse<ComboAcceptResponse>>(
      API_ENDPOINTS.COMBOS.QUOTE_ACCEPT(rfqId),
      { quote },
    );
    return data;
  },

  /** Poll fill status for an accepted RFQ */
  getQuoteStatus: async (rfqId: string): Promise<ApiResponse<ComboRfqStatusResponse>> => {
    const { data } = await axiosClient.get<ApiResponse<ComboRfqStatusResponse>>(
      API_ENDPOINTS.COMBOS.QUOTE_STATUS(rfqId),
    );
    return data;
  },

  /** List the user's combo positions */
  listPositions: async (
    params?: ComboListParams,
  ): Promise<ApiResponse<ComboListResponse<ComboPosition>>> => {
    const { data } = await axiosClient.get<ApiResponse<ComboListResponse<ComboPosition>>>(
      API_ENDPOINTS.COMBOS.POSITIONS,
      { params },
    );
    return data;
  },

  /** List the user's combo activity */
  listActivity: async (
    params?: ComboListParams,
  ): Promise<ApiResponse<ComboListResponse<ComboActivityItem>>> => {
    const { data } = await axiosClient.get<ApiResponse<ComboListResponse<ComboActivityItem>>>(
      API_ENDPOINTS.COMBOS.ACTIVITY,
      { params },
    );
    return data;
  },
};
